<template>
  <APageHead
    title="동영상 관리"
    sub="동영상 컨텐츠를 관리하고 운영합니다"
    icon="play_circle"
  />

  <div class="cn-page">
    <TabNav
      v-model="activeTab"
      :tabs="[
        { id: 'textbook',  label: $t('navi.04_01'), icon: 'menu_book' },
      ]"
    />

    <ACard :padding="40">
      <div class="cs">
        <div class="cs__mochi">
          <MochiCharacter :size="180" expr="sleepy" />
        </div>

        <p class="cs__eyebrow">COMING SOON</p>
        <h2 class="cs__title">동영상 서비스 준비중</h2>
        <p class="cs__desc">
          더 나은 서비스를 제공하기 위해<br />
          현재 열심히 준비하고 있습니다.
        </p>

        <div class="cs__features">
          <div class="cs-feature">
            <div class="cs-feature__icon">
              <i class="material-icons-round">video_library</i>
            </div>
            <h6 class="cs-feature__title">다양한 콘텐츠</h6>
            <p class="cs-feature__desc">풍부한 동영상 라이브러리</p>
          </div>
          <div class="cs-feature">
            <div class="cs-feature__icon">
              <i class="material-icons-round">cloud_download</i>
            </div>
            <h6 class="cs-feature__title">온라인 재생</h6>
            <p class="cs-feature__desc">언제 어디서나 재생 가능</p>
          </div>
          <div class="cs-feature">
            <div class="cs-feature__icon">
              <i class="material-icons-round">tune</i>
            </div>
            <h6 class="cs-feature__title">맞춤 설정</h6>
            <p class="cs-feature__desc">화질 / 자막 / 재생 속도</p>
          </div>
        </div>

        <div class="cs__actions">
          <ABtn kind="ghost" icon="arrow_back" @click="goBack">돌아가기</ABtn>
        </div>
      </div>
    </ACard>
  </div>
</template>

<script>
import TabNav from "@/components/TabNav.vue";
import APageHead from "@/components/Pineapple/APageHead.vue";
import ACard from "@/components/Pineapple/ACard.vue";
import ABtn from "@/components/Pineapple/ABtn.vue";
import MochiCharacter from "@/components/Pineapple/MochiCharacter.vue";

export default {
  name: "ContentsVideos",
  components: { TabNav, APageHead, ACard, ABtn, MochiCharacter },
  data() {
    return { activeTab: 'video' };
  },
  watch: {
    activeTab(newValue) {
      const routes = {
        textbook: 'ContentsTextbooks',
        audiobook: 'ContentsAudiobooks',
        video: 'ContentsVideos',
      };
      if (this.$route.name !== routes[newValue]) {
        this.$router.push({ name: routes[newValue] });
      }
    },
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/pineapple";

.cn-page {
  padding: 20px 0 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  font-family: $p-font-body;
}

.cs {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 16px 0;
}

.cs__mochi {
  margin-bottom: 8px;
}

.cs__eyebrow {
  margin: 0;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.18em;
  color: $p-point-deep;
}

.cs__title {
  margin: 6px 0 12px;
  font-size: 24px;
  font-weight: 800;
  color: $p-ink;
  letter-spacing: -0.02em;
}

.cs__desc {
  margin: 0 0 32px;
  font-size: 14px;
  color: $p-ink-mid;
  line-height: 1.6;
}

.cs__features {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
  width: 100%;
  max-width: 720px;
  margin: 0 0 32px;
}

.cs-feature {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 20px 16px;
  background: $p-panel-alt;
  border: 1px solid $p-line;
  border-radius: $p-radius;
}

.cs-feature__icon {
  width: 48px;
  height: 48px;
  display: grid;
  place-items: center;
  background: $p-point-soft;
  border: 1px solid $p-point-deep;
  border-radius: 50%;
  color: $p-point-deep;

  i { font-size: 24px; }
}

.cs-feature__title {
  margin: 0;
  font-size: 13px;
  font-weight: 800;
  color: $p-ink;
}

.cs-feature__desc {
  margin: 0;
  font-size: 11px;
  color: $p-ink-mid;
  line-height: 1.5;
}

.cs__actions {
  display: inline-flex;
  gap: 8px;
}

@media (max-width: 768px) {
  .cs__features { grid-template-columns: 1fr; }
}
</style>
